import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { useField } from "vee-validate";
import { useAttrs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitNumberInput',
  props: {
    name: {},
    label: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    wrapperClass: {}
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.wrapperClass || 'a',
            props.horizontal && 'horizontal-wrapper',
        ])
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      class: _normalizeClass(props.horizontal ? 'form-item-horizontal' : ''),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, _mergeProps({
          placeholder: props.label,
          name: props.name
        }, _unref(attrs), {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          "validate-event": false
        }), null, 16, ["placeholder", "name", "modelValue"])
      ]),
      _: 1
    }, 8, ["error", "class", "validateStatus"])
  ], 2))
}
}

})